export default __webpack_public_path__ + "assets/enterprise-one-two.22beee88c0e5332ec053faf68163bffd.png";